import React from 'react'
import styled from '@emotion/styled'

import lensImg from './lens.svg'

const Root = styled.div`
`

const Input = styled.input`
  width: 100%;
  border: 0 solid #ccc;
  border-radius: 0;
  border-bottom-width: 2px;
  padding: 10px 15px 8px 25px;
  box-sizing: border-box;
  background: transparent url(${lensImg}) 0 11px no-repeat;
  background-size: 17px;
  color: #333;
  font: 15px/1 Merriweather, serif;
  font-style: italic;
  transition: border-color 0.2s;

  &:focus {
    outline: none;
    border-color: #95bb9e;
  }
`

const SearchBar = ({searchQuery, setSearchQuery, placeholder}) => <Root>
  <Input value={searchQuery} onChange={(event) => {
    setSearchQuery(event.target.value)
  }} placeholder={placeholder}/>
</Root>


export default SearchBar
